import pictogramArticle from "assets/img/pictogram/article.svg"

import { useTranslation } from "react-i18next"

import { ArticleShort } from "models/ArticleShort"
import SelectSearchOption from "./SelectSearchOption"
import { ArticleType } from "config/constants"
import Highlighter from "components/Highlighter/Highlighter"
import ArticleDescription from "components/ArticleDescription/ArticleDescription"

interface ISelectSearchOptionArticle {
    article: ArticleShort
    onShowDetailsClick(): void
    highlight?: string
}

const SelectSearchOptionArticle = ({
    article,
    onShowDetailsClick,
    highlight = ""
}: ISelectSearchOptionArticle) => {
    const { t } = useTranslation()

    return (
        <SelectSearchOption
            title={<ArticleDescription articleDescription={article.description} highlight={highlight} />}
            badge={article.articleType === ArticleType.zts ? t('common.zts') : undefined}
            subtitle={
                <>
                {t('common.artNo')}: <Highlighter text={article.articleNo} highlight={highlight} />
                    {article.manufacturerDescription && article.manufacturerArticleNo &&
                        <>
                            <span className="px-1">|</span>
                            <Highlighter text={article.manufacturerDescription} highlight={highlight} />
                            {!!article.manufacturerDescription && " / "}
                            <Highlighter text={article.manufacturerArticleNo} highlight={highlight} />
                        </>
                    }
                    {article.articleType !== ArticleType.machine && article.articleTypeDescription &&
                        <>
                            <span className="px-1">|</span>
                            <Highlighter text={article.articleTypeDescription} highlight={highlight} />
                        </>
                    }
                </>
            }
            thumbnailUrl={article.thumbnailUri}
            pictogramUrl={pictogramArticle}
            onShowDetailsClick={onShowDetailsClick}
        />
    )
}

export default SelectSearchOptionArticle
